import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";

import { Heading } from "../../components";
import { SwitchYourSiteMessage } from "../components";

export const CrossflowEligibleUser = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <Heading>
            <FormattedMessage
                id="signup.teamworkCollection.uplift.heading"
                defaultMessage="Switch your site to Teamwork Collection"
            />
        </Heading>
        <SiteActivation CrossflowEligibleUser={<SwitchYourSiteMessage />} />
    </SignupBackgroundLayout>
);
